import { SELECT_CAR, RECEIVE_AUTOS } from "../actions/cars";

const carsReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECT_CAR:
      return (state = { ...state, car: action.car });
      break;
    case RECEIVE_AUTOS:
      return (state = { ...state, autos: action.autos });
    default:
      return state;
  }
};

export default carsReducer;
